import _ from "lodash";
// Import numerology calculator inline module
import NumerologyCalculatorInline from "../numerology-calculator/inline.js";
// import { ProductForm } from '@shopify/theme-product-form'

class ProductFormElement extends HTMLElement {
  constructor() {
    super();
    this.isCustomily = document
      .querySelector("product-main")
      .getAttribute("customily");
    this.isNoPreviewCustomily = document
      .querySelector("product-main")
      .getAttribute("customily_no_preview");
    this.deactiveUnusedOptions = debounce(
      this.deactiveUnusedOptions.bind(this),
      100
    );
    this.onOptionChange = debounce(this.onOptionChange.bind(this), 100);
    if (this.dataset.variants) {
      this.variants = JSON.parse(this.dataset.variants);
    }
    this.gallery = document.querySelector("product-gallery");
    const formEl = this.querySelector("form");
    this.deactiveUnusedOptions();
    formEl.addEventListener("onOptionChange", (e) => {
      this.deactiveUnusedOptions();
      if (e.target.hasAttribute("data-option")) {
        this.onOptionChange(e, "opt");
      }
    });
    formEl.addEventListener("change", (e) => {
      if (e.target.closest("[data-option]")) {
        this.deactiveUnusedOptions();
        this.onOptionChange(e, "sel");
      }
    });

    formEl.addEventListener("submit", (e) => {
      e.preventDefault();
      //console.log("[ProductForm] form submit");
      document.querySelector("shopify-cart").addItemFromForm(e.target);
    });

    if (this.isCustomily != "true" || this.isNoPreviewCustomily == "true") {
      this.gallery
        .querySelector(".swiper-wrapper")
        .classList.add("!duration-0");
      this.gallery.ShowSelectedID(this.querySelector('input[name="id"]').value);
    }

    // Initialize numerology calculator if present
    this.initializeNumerologyCalculator();

    function debounce(func, wait) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }
  }

  initializeNumerologyCalculator() {
    // Look for numerology calculator wrapper in this product form
    const numerologyWrapper = this.querySelector(
      '[data-module="numerology-calculator-inline"]'
    );
    if (numerologyWrapper) {
      new NumerologyCalculatorInline(numerologyWrapper);
    }
  }

  deactiveUnusedOptions() {
    console.log("deactiveUnusedOptions");
    let options = this.querySelectorAll("options-input");
    let opt1 = options[0]?.getAttribute("selected_id") || null;
    let opt2 =
      options.length > 1
        ? options[1]?.getAttribute("selected_id") || null
        : null;
    let opt3 =
      options.length > 2
        ? options[2]?.getAttribute("selected_id") || null
        : null;
    let selectedOptions = { option1: opt1, option2: opt2, option3: opt3 };

    // Filter variants based on selected options
    const filteredVariantsForLevel2 = this.variants.filter((variant) => {
      return (
        !selectedOptions.option1 || variant.option1 === selectedOptions.option1
      );
    });

    const filteredVariantsForLevel3 = this.variants.filter((variant) => {
      return (
        (!selectedOptions.option1 ||
          variant.option1 === selectedOptions.option1) &&
        (!selectedOptions.option2 ||
          variant.option2 === selectedOptions.option2)
      );
    });

    // Extract valid options for each level based on filtered variants
    const validOptionsForLevel2 = {
      option2: [
        ...new Set(filteredVariantsForLevel2.map((variant) => variant.option2)),
      ],
      option3: [
        ...new Set(filteredVariantsForLevel2.map((variant) => variant.option3)),
      ],
    };

    const validOptionsForLevel3 = {
      option3: [
        ...new Set(filteredVariantsForLevel3.map((variant) => variant.option3)),
      ],
    };

    // Deactivate options not in validOptions for each select element
    Array.from(options).forEach((option, index) => {
      if (index === 0) return; // Skip option1

      let validOptions =
        index === 1
          ? validOptionsForLevel2.option2
          : validOptionsForLevel3.option3;

      Array.from(option.querySelectorAll(".opt")).forEach((optionElement) => {
        if (!validOptions.includes(optionElement.getAttribute("value"))) {
          optionElement.setAttribute("aria-disabled", "true");
        } else {
          optionElement.removeAttribute("aria-disabled");
        }
      });

      // Automatically select the first available option if the current selection is disabled
      if (
        index === 1 &&
        selectedOptions.option2 &&
        !validOptions.includes(selectedOptions.option2)
      ) {
        const firstAvailableOption = option.querySelector(
          ".opt:not([aria-disabled='true'])"
        );
        if (firstAvailableOption) {
          firstAvailableOption.click();
        }
      }

      if (
        index === 2 &&
        selectedOptions.option3 &&
        !validOptions.includes(selectedOptions.option3)
      ) {
        const firstAvailableOption = option.querySelector(
          ".opt:not([aria-disabled='true'])"
        );
        if (firstAvailableOption) {
          firstAvailableOption.click();
        }
      }
    });
  }

  backInStock(event) {
    event.preventDefault();
    let email_field = this.querySelector("#backinstockemail");
    let error_message = this.querySelector("#backinstockemail + .hidden");
    let button = this.querySelector("#backinstockemail ~ button");
    let email = email_field.value;
    let variant = this.querySelector("form").id.value;
    if (email == "") {
      // missing email
      error_message.classList.remove("hidden");
      return;
    }

    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: "$shopify:::$default:::" + variant,
            },
          },
        },
      },
    };

    var requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: "2023-12-15",
      },
      body: JSON.stringify(payload),
    };

    fetch(
      "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=VhnDTq",
      requestOptions
    ).then((response) => {
      if (response.status == 202) {
        error_message.classList.add("hidden");
        email_field.classList.add("send");
        email_field.classList.add("hidden");
        //subscribed
        button.classList.remove("btn-primary", "text-anna-gray");
        button.classList.add(
          "bg-white",
          "border",
          "border-black",
          "cursor-default",
          "text-anna-black"
        );
        button.setAttribute("onclick", "event.preventDefault();");
        button.setAttribute("disabled", "");
        if (window.location.pathname.includes("/en")) {
          button.innerHTML = "Notification active";
        } else {
          button.innerHTML = "Benachrichtigung aktiv";
        }
      }
      if (response.status == 400) {
        error_message.classList.remove("hidden");
      }
    });
  }

  onOptionChange(event, type) {
    const formEl = this.querySelector("form");
    //console.log("Change detected");

    let option1 = "";
    let option2 = "";
    let option3 = "";
    if (type == "opt") {
      option1 = formEl
        .querySelector('options-input[data-option="1"]')
        ?.getAttribute("selected_id");
      option2 = formEl
        .querySelector('options-input[data-option="2"]')
        ?.getAttribute("selected_id");
      option3 = formEl
        .querySelector('options-input[data-option="3"]')
        ?.getAttribute("selected_id");
    }
    if (type == "sel") {
      option1 = formEl.querySelector('select-input [data-option="1"]')?.value;
      option2 = formEl.querySelector('select-input [data-option="2"]')?.value;
      option3 = formEl.querySelector('select-input [data-option="3"]')?.value;
    }

    if (
      (this.isCustomily != "true" &&
        event.target.hasAttribute("gallery_relevant")) ||
      (this.isNoPreviewCustomily == "true" &&
        event.target.hasAttribute("gallery_relevant"))
    ) {
      this.gallery.ShowSelectedType(option1 || null);
    }

    let matchingVariant = _.find(this.variants, {
      option1: option1 || null,
      option2: option2 || null,
      option3: option3 || null,
    });

    //console.log("matchingVariant", matchingVariant);

    if (!matchingVariant) {
      // Fallback mechanism for option1 and option2
      if (option1) {
        matchingVariant = _.find(this.variants, {
          option1: option1,
        });
        console.log(matchingVariant);
        if (matchingVariant) {
          // Update the selected option for layer 2
          const option2Element = this.querySelector(
            'options-input .option div[value="' + matchingVariant.option2 + '"]'
          );
          if (option2Element) {
            option2Element.click();
          }
        }
      }

      // Fallback mechanism for option1, option2, and option3
      if (option1 && option2) {
        matchingVariant = _.find(this.variants, {
          option1: option1,
          option2: option2,
        });
        console.log(matchingVariant);
        if (matchingVariant) {
          // Update the selected option for layer 3
          const option3Element = this.querySelector(
            'options-input .option div[value="' + matchingVariant.option3 + '"]'
          );
          if (option3Element) {
            option3Element.click();
          }
        }
      }
    } else {
      // Update the form with the matching variant
      this.querySelector('input[name="id"]').value = matchingVariant.id;

      window.Shopify.analytics.publish("pdp:variant_change", matchingVariant);

      this.dispatchEvent(
        new CustomEvent("change-variant", {
          detail: { id: matchingVariant.id },
          bubbles: true,
        })
      );
    }

    if (this.isCustomily != "true" || this.isNoPreviewCustomily == "true") {
      this.gallery.ShowSelectedID(this.querySelector('input[name="id"]').value);
    } else {
      this.gallery.gallerySlider.slideTo(0, 0);
    }
  }
}

customElements.define("product-form", ProductFormElement);
